import React, { createContext, useEffect, useState } from "react";
import { adminGetProfileData } from "../redux/auth/slice";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Provider } from "./layoutContext";
import Sidebar from "./Sidebar";
import Header from "./Header";
import RippleLoader from "../components/RippleLoader/RippleLoader";

export const AdminContext = createContext({});

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const location = useLocation();

  const [isAsideOpen, setIsAsideOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [windowScreenWidth, setwindowScreenWidth] = useState(window.innerWidth);

  const getAccessToken = sessionStorage.getItem("accessToken");

  const { getProfileData } = useSelector((store) => ({
    getProfileData: store?.authData?.adminGetProfileDataStatus?.data,
    // loading: store?.authData?.loading,
  }));

  useEffect(() => {
    if (getAccessToken) {
      dispatch(adminGetProfileData({ navigate })).then(() => {
        setIsLoading(false);
      });
    }
  }, [dispatch, getAccessToken]);

  useEffect(() => {
    function handleResize() {
      setwindowScreenWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    windowScreenWidth < 767 && setIsAsideOpen(false);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowScreenWidth]);

  return (
    <div className={`bg-lightyellow ${isLoading ? "h-screen" : ""}`}>
      {getAccessToken ? (
        <AdminContext.Provider value={getProfileData}>
          <Provider value={{ isAsideOpen, setIsAsideOpen }}>
            {isLoading ? (
              <RippleLoader />
            ) : (
              <div
                className={`h-screen flex flex-col min-w-0 flex-1 overflow-y-hidden overflow-x-hidden`}
              >
                <Header />
                <div className="flex">
                  <Sidebar />
                  <div className="h-[calc(100vh-4rem)] overflow-y-auto bg-light_background_default w-full px-6 py-8">
                    <Outlet />
                  </div>
                </div>
              </div>
            )}
          </Provider>
        </AdminContext.Provider>
      ) : (
        <>
          <Navigate to={"/login"} replace />
        </>
      )}
    </div>
  );
};

export default MainLayout;
